import {Component, Input, OnInit} from "@angular/core";
import {BillData} from "../../../shipper";
import {arrayChunk} from "../../misc";
import {NgForOf} from "@angular/common";

@Component({
	selector: 'isf-bill-containers',
	standalone: true,
	imports: [
		NgForOf
	],
	template: `
        <table class="table- table-sm">
            <tr *ngFor="let row of containers">
                <td *ngFor="let c of row">
                    <span class="text-secondary" title="{{c}}">{{ c }}</span>
                </td>
            </tr>
        </table>
	`,
	styles:[`
		span{
			font-size: 11px;
		}
	`]
})
export class IsfBillsContainers implements OnInit{
	
	@Input()
	bill!:BillData;
	
	containers:Array<Array<string>> = [];
	
	
	ngOnInit(): void {
		
		if(this.bill && this.bill.containers){
			let c = this.bill.containers.map(c => c.containerNumber);
			this.containers = arrayChunk(c,4);
		}
	}
	
}
